import { createSelector } from '@ppl/store';
import type { BehaviorSubject } from 'rxjs';


export function select<S, R>(selector: (state: S) => R) {
  return (state: S) => {
    return selector(state);
  };
}

export function createStatePropertySelector<S, K extends keyof S>(key: K) {
  return createSelector<S, S[K], S[K]>(
    state => state[key],
    value => value
  );
}

export function updateState<S>(state$: BehaviorSubject<S>, update: Partial<S>): void {
  state$.next({ ...state$.value, ...update });
}
